import moment from 'moment';

export class Utils {


    // tslint:disable-next-line: no-any
    static isNil = (val: any) => val === undefined || val === null;

    static isNillOrEmpty = (val: any[]) => {
        return Utils.isNil(val) || val.length < 1;
    }

    // tslint:disable-next-line: no-any
    static isNullOrWhiteSpace = (val: any) => {
        try {
            if (Utils.isNil(val)) {
                return true;
            }
            return val.toString().replace(/\s/g, '').length < 1;
        } catch (e) {
            return false;
        }
    };


    // tslint:disable-next-line: no-any
    static getFullDateFromDateAndTime = (date: any, time: any) => {
        if (Utils.isNil(date)) {
            return null;
        }

        if(!Utils.isNil(time)) {
            time = time.split(':');
        }

        let result = moment.utc(date)
            .startOf('day');

        return Utils.isNil(time) ? 
            result.toDate() :
            result.add('hours', time[0]).add('minutes', time[1]).toDate();
    };
}
